var option_webview_default = {
  "option": "zZkwu",
  "user_choice": "_-3n8N",
  "check": "miZ89",
  "image": "Egi7B",
  "input": "_1DLB8",
  "title": "ueBEX",
  "centered": "_2PQj5",
  "with_result": "_821N-",
  "list": "duNqK",
  "with_image": "nZIrU",
  "progress": "y--PH",
  "progress_value": "GZWTg",
  "label": "ipVfh",
  "cta": "Holjj",
  "adornment_icon": "X-ac-",
  "remove": "_3z0KJ",
  "removeButton": "Je9oo",
  "removeButtonIcon": "RLKRp",
  "overlay": "FgwED",
  "shown": "WWQjR",
  "dark": "ja63H",
  "spinner": "mwQpD",
  "spin": "y-RgJ",
  "grid": "_1iCR1"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
